import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { UserService } from '../../../_services/user.service';
import { isPlaceholderTechnician } from '../../../_models/shipping-config-rules';

export interface TechnicianOption {
  id: number;
  name: string;
}

export interface WarehouseOption {
  id: number;
  label: string;
}

/**
 * Lädt die Auswahllisten des Versandziel-Dialogs (Techniker eines Projekts und
 * deren Umbuchungslager). Bewusst schlank und nur für den Dialog: die
 * gleichnamigen Methoden im alten Versandconfig-Formular sind mit dessen
 * Formular-State verwoben und bleiben deshalb unangetastet.
 */
@Injectable({ providedIn: 'root' })
export class ShippingTargetOptionsService {
  private userService = inject(UserService);

  /** Wählbare Ziel-Techniker (ohne Platzhalter-/System-User), nach Namen sortiert. */
  async technicians(projectId?: number): Promise<TechnicianOption[]> {
    const params = projectId ? { project_id: projectId } : {};
    const data = (await firstValueFrom(this.userService.getTechnicians(params))) as Array<{
      id: number;
      name?: string;
      full_name?: string;
    }>;

    return (data ?? [])
      .filter((u) => !isPlaceholderTechnician(u.id))
      .map((u) => ({ id: u.id, name: u.full_name || u.name || `#${u.id}` }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  /** Umbuchungslager eines Technikers. */
  async warehouses(userId: number): Promise<WarehouseOption[]> {
    const data = (await firstValueFrom(this.userService.getUsersWarehouses(userId))) as Array<{
      id: number;
      label: string;
    }>;

    return (data ?? []).map((w) => ({ id: w.id, label: w.label }));
  }
}
